import LiveCasinoBaccaratRedux from './live_casino_baccarat_redux';

export default LiveCasinoBaccaratRedux;
